import { render, staticRenderFns } from "./PersonCreationComponent.vue?vue&type=template&id=75011c42&scoped=true&"
import script from "./PersonCreationComponent.vue?vue&type=script&lang=ts&"
export * from "./PersonCreationComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PersonCreationComponent.vue?vue&type=style&index=0&id=75011c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75011c42",
  null
  
)

export default component.exports